import bulk from './feedback/bulk.js';
import comments from './feedback/comments.js';
import manualScores from './feedback/manual-scores.js';
import rubrics from './feedback/rubrics.js';
import visibility from './feedback/visibility.js';

var sendScoreAndComments = function sendScoreAndComments(userKey, cardstackKey) {
  return Promise.all([comments.sendComments(userKey, cardstackKey), manualScores.sendManualScore(userKey, cardstackKey)]);
};

var markAllFeedbackAsRead = function markAllFeedbackAsRead(manualScoreKeys, commentKeys) {
  var markReadPromises = [];

  if (manualScoreKeys.length) {
    markReadPromises.push(manualScores.markAllManualScoresAsRead(manualScoreKeys));
  }

  if (commentKeys.length) {
    markReadPromises.push(comments.markAllCommentsAsRead(commentKeys));
  }

  return Promise.all(markReadPromises);
};

export default Object.assign({
  sendScoreAndComments: sendScoreAndComments,
  markAllFeedbackAsRead: markAllFeedbackAsRead
}, manualScores, comments, rubrics, bulk, visibility);